import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "companyFields"]

  toggle() {
    const selected = this.radioTargets.find(r => r.checked)
    if (selected && selected.value === "azienda") {
      this.companyFieldsTarget.classList.remove("d-none")
    } else {
      this.companyFieldsTarget.classList.add("d-none")
    }
  }
}
